import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { GCI140Service } from '../../../../services/gci140.service';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { AuthenticationService } from '../../../../services/authentication.service';

@Component({
  selector: 'i140-review-comment',
  templateUrl: './review-comment.component.html',
  styleUrls: ['./review-comment.component.scss']
})
export class ReviewCommentComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('reviewCommentForm', { static: true }) reviewCommentForm: NgForm;

  isUserHasReviewerPermission: boolean;
  listDocuments: any;

  @Input()
  disabledControls: boolean;

  @Input()
  dialogConfigData: any;

  observableSubscription$ = new Subject();

  constructor(
    private gcI140Service: GCI140Service,
    private toastr: ToastrService,
    private store: Store<any>,
    private authenticationService: AuthenticationService,
  ) {
    this.listDocuments = [];
    this.isUserHasReviewerPermission = false;
    this.disabledControls = false;
  }

  ngOnInit(): void {
    this.getReviewComments();
    this.isUserHasReviewerPermission = this.authenticationService.currentUserValue ? this.authenticationService.currentUserValue['permissions'].find(x => x === 'PETITION_REVIEWER') ? true : false : false;
  }

  ngAfterViewInit() {
    this.reviewCommentForm.valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
      if (this.reviewCommentForm.dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      }
    });
  }

  getReviewComments() {
    this.gcI140Service.getI140ReviewComments(this.dialogConfigData.data.superTaskId, this.dialogConfigData.data.i140CaseId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.data && response.data.length > 0) {
        this.listDocuments = response.data.filter((x) => {
          return x['docs'] = x['docs'].filter(y => y['isReviewReq'] === 1);
        });
      }
    });
  }

  handleSave(currentItem, refItem = null) {
    const payload = {
      "comments": currentItem.comments,
      "petitionId": this.dialogConfigData.data.i140CaseId,
      "titleSheetDetailId": currentItem.titleSheetDetailId,
      "titleSheetId": refItem ? refItem.titleSheetId : currentItem.titleSheetId,
    }
    this.gcI140Service.postI140ReviewComments(this.dialogConfigData.data.superTaskId, this.dialogConfigData.data.i140CaseId, payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      this.toastr.success(response.message, 'Success');
    });
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

}
